import { Component } from '@angular/core';
@Component({
  selector: 'app-accessdenied',
  templateUrl: './app.accessdenied.component.html',
  styleUrls: ['./app.accessdenied.component.scss']
})
export class AppAccessdeniedComponent {
  redirectToLogin(){
    localStorage.clear();
     window.location.href = '/login';
  }
}
